import { Link } from "react-router-dom";

const FOUNDER_IMG = "https://customer-assets-m6fa6gv7.emergentagent.net/job_looxs-ecommerce/artifacts/p0auqnyq_30BA266F-4E88-4859-BD2C-64C6C4891FCF.jpeg";

export default function Founder() {
  return (
    <div className="bg-ivory text-ink">
      <section className="pt-32 pb-8 text-center">
        <p className="text-[10px] tracking-luxury uppercase text-gold mb-6">The Founder</p>
        <h1 className="font-editorial text-6xl md:text-8xl leading-[0.95] tracking-tight">Mohammad Firoz</h1>
        <div className="rule-gold w-32 mx-auto my-10" />
      </section>
      <section className="max-w-[1400px] mx-auto px-8 md:px-16 grid md:grid-cols-12 gap-12 py-16">
        <div className="md:col-span-6">
          <img src={FOUNDER_IMG} alt="Mohammad Firoz" className="w-full aspect-[4/5] object-cover" />
        </div>
        <div className="md:col-span-6 md:pl-8 max-w-xl">
          <p className="text-[10px] tracking-widest-plus uppercase text-black/50 mb-4">Portrait</p>
          <h2 className="font-editorial text-5xl md:text-6xl leading-[1] tracking-tight">Mohammad Firoz.</h2>
          <p className="mt-3 font-editorial-italic text-2xl text-gold">Founder & CEO, LOOXS Fashion.</p>
          <div className="rule-gold w-16 my-8" />
          <div className="space-y-6 text-lg leading-relaxed text-ink/85 font-light">
            <p>My journey has always been driven by a deep passion for fashion, people and purpose.</p>
            <p>From managing retail operations across diverse markets to building strong teams and delivering exceptional customer experiences, I have learned that true style goes beyond what you wear — it is about the confidence it gives you.</p>
            <p>LOOXS Fashion is the result of that belief. A house built on the idea that luxury should feel personal, quality should be uncompromised, and fashion should empower individuals to express their best selves every single day.</p>
            <p>Every collection we create carries my vision of blending timeless elegance with contemporary design — inspired by London, crafted with pride in India.</p>
            <p className="font-editorial-italic text-xl">My goal is simple — to build a house that people trust, love and feel proud to be a part of.</p>
          </div>
          <p className="font-editorial-italic text-2xl mt-10 text-gold">— Mohammad Firoz</p>
          <p className="text-[10px] tracking-widest-plus uppercase text-black/50 mt-1">Founder, LOOXS Fashion</p>
          <p className="text-sm mt-6"><span className="text-[10px] tracking-widest-plus uppercase text-black/50 mr-2">Office of the CEO ·</span><a href="mailto:ceo@looxsfashion.com" data-testid="ceo-email" className="link-draw text-gold">ceo@looxsfashion.com</a></p>
        </div>
      </section>
      <section className="section-dark py-24 md:py-32 mt-16">
        <div className="max-w-4xl mx-auto text-center px-8">
          <p className="text-[10px] tracking-luxury uppercase text-gold mb-6">The Principles</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-12">
            <Principle title="Passion drives us" body="Fashion is not a product. It is a choice, a language, a signature." />
            <Principle title="Quality defines us" body="Every seam, button and thread is considered. Every piece will outlast the season." />
            <Principle title="People inspire us" body="The house is built for the individual who wears LOOXS as identity." />
          </div>
          <Link to="/world" className="inline-block mt-16 tracking-widest-plus text-[11px] uppercase text-gold link-draw">Continue into the world →</Link>
        </div>
      </section>
    </div>
  );
}

function Principle({ title, body }) {
  return (
    <div>
      <p className="font-editorial text-2xl mb-3">{title}</p>
      <p className="text-sm text-ivory/70 leading-relaxed">{body}</p>
    </div>
  );
}
